module.exports = __webpack_public_path__ + "img/header_left_icon.d21efec1.png";